import { Status } from 'queries/assets/contract';
import React from 'react';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useTranslation } from 'react-i18next';
import './style.scss';

interface EventStatusProps {
  status: Status;
}

const EventStatus: React.FC<EventStatusProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <div className={`event-status ${status && status.toLowerCase()}`}>
      {status === 'OPEN' && (
        <>
          <NotificationsActiveOutlinedIcon fontSize="small" />{' '}
          {t('event_page:status_count_panel.status.status.OPEN')}{' '}
        </>
      )}
      {status === 'CLOSED' && (
        <>
          <CheckCircleOutlineOutlinedIcon fontSize="small" />{' '}
          {t('event_page:status_count_panel.status.status.CLOSED')}
        </>
      )}
      {status === ('-' as Status) && '-'}
    </div>
  );
};

export default EventStatus;
